/**
 * credit type
 */
export enum CreditType {
  Dollar = 'Dollar',
  Percentage = 'Percentage',
  Quantity = 'Quantity',
}
